
define('text!modules/reporting/segments/dataExport/manage/templates/header.html',[],function () { return '<div class="btn-add-report">\n\t<strand-button value="" type="primary" unresolved>\n\t\t<strand-icon type="plus" optimize="true" width="12" height="12" unresolved></strand-icon><label>Add Report</label>\n\t</strand-button>\n</div>';});

